import { render, staticRenderFns } from "./NetworkNotification.vue?vue&type=template&id=24fb1e9e&scoped=true"
import script from "./NetworkNotification.ts?vue&type=script&lang=ts&external"
export * from "./NetworkNotification.ts?vue&type=script&lang=ts&external"
import style0 from "./NetworkNotification.vue?vue&type=style&index=0&id=24fb1e9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb1e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fb1e9e')) {
      api.createRecord('24fb1e9e', component.options)
    } else {
      api.reload('24fb1e9e', component.options)
    }
    module.hot.accept("./NetworkNotification.vue?vue&type=template&id=24fb1e9e&scoped=true", function () {
      api.rerender('24fb1e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/NetworkNotification/NetworkNotification.vue"
export default component.exports